(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('notificationService', notificationService);

    notificationService.$inject = ['$window', 'Notification', '$timeout'];

    function notificationService($window, appNotification, $timeout) {

        var isWindowOpen = true;


        $window.addEventListener('focus', function (e) {
            isWindowOpen = true;
        });

        $window.addEventListener('blur', function (e) {
            isWindowOpen = false;
        });
        
        return {
            sendNotification : sendNotification,
            sendHTMLNotification : sendHTMLNotification,
            sendAppNotification : sendAppNotification
        };

        function sendNotification(notification){
            if(isWindowOpen){
                sendAppNotification(notification);
            } else {
                sendHTMLNotification(notification);
            }
        }

        function sendHTMLNotification(notification){
            if(window.Notification && Notification.permission !== 'denied') {
                Notification.requestPermission(function(status) {  // status is "granted", if accepted by user
                    var n = new Notification(notification.title, { 
                        body: notification.message,
                        icon: notification.icon
                    }); 
                    n.onclick = function(){
                        notification.onclick();
                        n.close();
                    };

                    $timeout(function(){
                        n.close();
                    }, notification.delay || 8000);
                });
            }
        }

        function sendAppNotification(notification){
            appNotification({
                title : notification.title,
                message: notification.message,
                //templateUrl: notification.templateUrl, 
                templateUrl: notification.templateUrl || 'app/views/notification.html',
                delay: notification.delay, 
                positionY: notification.positionY,
                positionX: notification.positionX,
                replaceMessage: notification.replaceMessage,
                closeOnClick : notification.closeOnClick,
                scope: notification.scope
            },
            notification.type);
        }
    }
})();